import { render } from "./FPimg.vue?vue&type=template&id=a0399070&scoped=true"
import script from "./FPimg.vue?vue&type=script&lang=js"
export * from "./FPimg.vue?vue&type=script&lang=js"

import "./FPimg.vue?vue&type=style&index=0&id=a0399070&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Benjamin\\Desktop\\Hudplejeklinikken Esbjerg\\code\\hpke\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0399070"]])

export default __exports__